import React from 'react';
import EmptyState from './EmptyState';
import Loader from './Loader';

export default function DataTable({
  columns,
  data = [],
  loading = false,
  emptyTitle,
  emptyMessage,
  align = {},
  keyField = 'id',
  selectable = false,
  selectedIds = [],
  onSelectionChange,
}) {
  if (loading) return <Loader />;
  if (!data || data.length === 0) {
    return <EmptyState title={emptyTitle} message={emptyMessage} />;
  }

  const selectedSet = new Set(selectedIds);
  const allSelected = data.length > 0 && data.every((r) => selectedSet.has(r[keyField]));
  const someSelected = data.some((r) => selectedSet.has(r[keyField])) && !allSelected;

  const toggleAll = () => {
    if (!onSelectionChange) return;
    if (allSelected) {
      onSelectionChange([]);
    } else {
      onSelectionChange(data.map((r) => r[keyField]));
    }
  };

  const toggleRow = (id) => {
    if (!onSelectionChange) return;
    if (selectedSet.has(id)) {
      onSelectionChange(selectedIds.filter((sid) => sid !== id));
    } else {
      onSelectionChange([...selectedIds, id]);
    }
  };

  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            {selectable && (
              <th style={{ width: 40, textAlign: 'center' }}>
                <input
                  type="checkbox"
                  checked={allSelected}
                  ref={(el) => { if (el) el.indeterminate = someSelected; }}
                  onChange={toggleAll}
                />
              </th>
            )}
            {columns.map((col) => (
              <th key={col.key} className={align[col.key] === 'right' ? 'table-num' : ''}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr
              key={row[keyField] ?? i}
              className={selectedSet.has(row[keyField]) ? 'row-selected' : ''}
              style={selectedSet.has(row[keyField]) ? { backgroundColor: 'var(--primary-bg, #eff6ff)' } : {}}
            >
              {selectable && (
                <td style={{ textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={selectedSet.has(row[keyField])}
                    onChange={() => toggleRow(row[keyField])}
                  />
                </td>
              )}
              {columns.map((col) => {
                let cell = col.render ? col.render(row, i) : row[col.key];
                if (cell === undefined || cell === null) cell = '-';
                return (
                  <td key={col.key} className={align[col.key] === 'right' ? 'table-num' : ''}>
                    {cell}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
